<template>
  <div class="borrowBox">
    <div class="top">
      <h3 class="tip">
        <i></i>
        <span>{{$t('label.w135')}}</span>
      </h3>
      <div v-html="$t('other.w93')"></div>
    </div>
    <div class="borrowMsg">
      <h3 class="title">{{$t('title.w45')}}</h3>
      <div class="private" v-if="safe.ManagerLogin">
        <i class="icon-active i1">
          <p class="desc">{{$t('other.w94')}}</p>
        </i>
        <span>{{$t('label.w139')}}</span>
        <Input v-model="designeeId" @on-keyup="keyUp" />
        <i class="write"></i>
      </div>
      <Row class="content">
        <Col span="12">
          <div class="tit">
            <span>{{$t('title.w34')}}</span>
            <Checkbox
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll"
              v-if="dnlist.length"
            >{{$t('option.w1')}}</Checkbox>
          </div>
          <CheckboxGroup v-model="pledgeIds" @on-change="checkAllGroupChange">
            <ul class="list scrollbar" v-if="dnlist.length">
              <li v-for="v in dnlist" :key="v.Id">
                <Checkbox
                  :label="v.Id"
                >{{v.Name}} 【{{$t('label.w140')}}：￥{{v.AvailableAmount | money}}/￥{{v.CreditAmount | money}}】</Checkbox>
              </li>
            </ul>
          </CheckboxGroup>
          <div class="list2" v-if="!dnlist||!dnlist.length">
            <div class="bg"></div>
            <p class="link">
              {{$t('msg.m76')}}
              <router-link :to="{name:'domainManage'}">{{$t('btn.b74')}}</router-link>
            </p>
          </div>
        </Col>
        <Col span="12">
          <Row class="input-box">
            <Col span="12" class="block mar-b40">
              <span>{{$t('label.w2')}}</span>
              <Input
                v-model="amount"
                @on-change="handleChange('amount')"
                @on-blur="blurChage('amount')"
                :maxlength="value"
              />
              <span class="s1">{{$t('label.w5')}}</span>
              <p class="s2">
                <span v-show="amount">【{{amount | upmoney}}】</span>
                <span class="red">
                  {{$t('label.w141')}}¥{{amountUp | money}}
                  <span
                    v-show="amountUp"
                  >【{{amountUp | upmoney}}】</span>
                </span>
              </p>
            </Col>
            <Col span="12" class="block mar-b40">
              <span>{{$t('label.w80')}}</span>
              <Select v-model="loanCycleDay">
                <Option
                  v-for="(v,i) in loandays"
                  :key="i"
                  :value="v.v"
                >{{v.n}}{{v.t=='d'?$t('label.w15'):$t('label.w14')}}</Option>
              </Select>
            </Col>
            <Col span="12" class="block">
              <span>{{$t('label.w3')}}</span>
              <Input v-model="rate" @on-blur="handleBlur('rate')" />
              <span class="s1">%</span>
            </Col>
            <Col span="12" class="mangeRate">
              <span class="m1">
                {{$t('label.w137')}}
                <i class="icon-active i2">
                  <div class="ratelist">
                    <div class="time">
                      <p>{{$t('label.w80')}}</p>
                      <p>7天</p>
                      <p>15天</p>
                      <p>1-12个月</p>
                    </div>
                    <div class="rate">
                      <p>{{$t('label.w137')}}</p>
                      <p>{{mgrconfig.ManagementFeeRate7}}%/7天</p>
                      <p>{{mgrconfig.ManagementFeeRate15}}%/15天</p>
                      <p
                        v-for="(v,i) in mgrconfig.ManagementFeeRateConfig"
                        :key="i"
                      >{{`${v.ManagementFeeRate}%/${$t('other.w121')}`}} {{i==mgrconfig.ManagementFeeRateConfig.length-1?'>':'≤'}}{{v.Amount | cn}}）</p>
                    </div>
                  </div>
                </i>
              </span>
              <!-- <Select v-model="couponId">
                <Option v-for="v in couponlist" :key="v.Id" :value="v.Id">{{$t('option.w54').replace('{%}',$math.eval(`${v.Rate}*100`))}}</Option>
                <Option v-if="couponlist.length<=0" value="">{{$t('option.w36')}}</Option>
              </Select>-->
              <div class="mgrate">{{$math.eval(`${mgrate}*100`)}}%</div>
              <Select style="width: 90px" :placeholder="$t('label.w103')" v-model="couponId">
                <Option v-if="couponlist.length<=0" value>{{$t('option.w36')}}</Option>
                <Option
                  v-if="couponlist.length>0"
                  value
                  @click.native="noCoupon()"
                >{{$t('option.w68')}}</Option>
                <Option
                  v-for="v in couponlist"
                  :key="v.Id"
                  :value="v.Id"
                  @click.native="coupon(v.Rate)"
                >{{$t('option.w54').replace('{%}',$math.eval(`${v.Rate}*100`))}}</Option>
              </Select>
            </Col>
            <Col span="24" class="block1">
              <p>
                <span>{{$t('label.w82')}}</span>
                <span>({{$t('label.w136')}})</span>
              </p>
              <Input type="textarea" v-model="description" @input="desc" :maxlength="20"></Input>
              <span class="s3">{{remnant}}/20</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    <div class="confirmMsg">
      <h3 class="title">{{$t('title.w46')}}</h3>
      <p class="time">
        <i class="icon-active">
          <p class="desc">{{$t('other.w95')}}</p>
        </i>
        <span>{{$t('label.w90')}} {{expiredAt}}</span>
      </p>
      <div class="content">
        <div class="breakBox" v-show="loanInfoList.length">
          <div class="head" v-show="loanInfoList.length>1">
            <p>{{$t('msg.m75')}}</p>
          </div>
          <div class="relative">
            <Spin fix v-if="loanInfoLoading"></Spin>
            <ul>
              <li v-for="v in loanInfoList" :key="v.Id">
                <p>
                  <span>[{{v.PledgeName[0]}}] {{$t('other.w96').replace('{%}',v.PledgeName.length)}}</span>
                  <i class="i3" v-if="v.PledgeName.length>1" :title="v.PledgeName.join('、')">
                    <!-- <span class="desc1">{{v.PledgeName.join('、')}}</span> -->
                  </i>
                </p>
                <p>
                  {{$t('label.w2')}}
                  <span class="org">{{v.LoanAmount | money}}{{$t('label.w5')}}</span>
                </p>
                <p class="red">{{$t('msg.m74').replace('{%}',v.AutoInvestTip)}}</p>
              </li>
            </ul>
            <div v-show="submitState=='error'||submitState=='success'">
              <div v-if="submitState=='error'">
                <div class="text-error">
                  <Icon type="md-close-circle" />
                  {{$t('msg.m88')}}
                </div>
                <Button @click="submitState=null">{{$t('btn.b33')}}</Button>
              </div>
              <div class="text-success" v-if="submitState=='success'">
                <Icon type="md-checkmark-circle" />
                {{$t('msg.m89')}}
              </div>
            </div>
          </div>
        </div>
        <!-- <Row class="details-content" v-show="submitState!='success'&&submitState!='error'"> -->
        <Row class="details-content">
          <Col span="16">
            <Row>
              <Col span="8" class="detail">
                <div class="d1">
                  <p class="Light-color">{{$t('label.w75')}}</p>
                  <p>{{interest*stagCount | money}}{{$t('label.w5')}}</p>
                </div>
                <div class="d1 mg">
                  <p class="Light-color allmoney">
                    <span>{{$t('label.w76')}}</span>
                    <i class="icon-active i2">
                      <p
                        class="desc"
                        :style="{textAlign:'left'}"
                      >{{$t('label.w137')}} {{$math.eval(`(${mgrate}-${couponRate})*100`)}}% / {{loanCycleDay<30?loanCycleDay+$t('label.w15'):$t('label.w203')}}</p>
                    </i>
                  </p>
                  <p>
                    <span>{{mgfee*stagCount | money}}{{$t('label.w5')}}</span>
                    <del
                      class="Light-color"
                      v-if="couponRate"
                    >{{amount*mgrate | money}}{{$t('label.w5')}}</del>
                  </p>
                </div>
                <div class="d1" :style="{marginBottom:0}">
                  <p class="Light-color">{{$t('label.w142')}}</p>
                  <p>{{amount*couponRate | money}}{{$t('label.w5')}}</p>
                </div>
              </Col>
              <Col span="16" class="feenum">
                <p>{{$t('option.w55')}}</p>
                <p>
                  {{$t('label.w77').replace('{%}',stagCount)}} X {{$t('label.w78')}}
                  <span
                    class="org"
                  >{{mgfee+interest | money}}{{$t('label.w5')}}</span>
                  （{{$t('label.w52')}}
                  <span>{{interest | money}}</span>
                  {{$t('label.w5')}} + {{$t('label.w55')}}
                  <span>{{mgfee | money}}</span>
                  {{$t('label.w5')}}）
                </p>
                <p
                  :style="{marginBottom:0}"
                >{{$t('label.w79')}} {{Number(amount)+interest+mgfee | money}} {{$t('label.w5')}}</p>
              </Col>
            </Row>
          </Col>
          <Col span="8" class="release">
            <p>{{$t('label.w138')}}：{{Number(amount)+(interest+mgfee)*stagCount | money}}【{{Number(amount)+(interest+mgfee)*stagCount | upmoney}}】</p>
            <div class="check">
              <Checkbox class="Light-color" @on-change="agreechange" v-model="agree">
                {{$t('other.w63')}}
                <a
                  href="javascript:;"
                  @click="protocolShow([1,3])"
                >{{$t('other.w59')}}</a>/
                <a href="javascript:;" @click="protocolShow([3,1])">{{$t('other.w60')}}</a>
              </Checkbox>
            </div>
            <div class="btn">
              <Button
                :loading="submitState=='loading'"
                :disabled="btnDisable"
                @click="submit"
              >{{$t('btn.b32')}}</Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false" />
  </div>
</template>

<script>
import Protocol from "@/components/protocolModal";
import comp from "@/libs/comp";
import { loandays } from "@/libs/sysconst";
export default {
  components: { Protocol },
  data() {
    return {
      loandays,
      dnlist: [],
      indeterminate: false,
      checkAll: false,
      amountUp: 0, //借款上限
      agree: false,
      aa: [],
      // 提交数据->
      pledgeIds: [],
      amount: "",
      couponId: "",
      rate: "",
      description: "",
      loanCycleDay: loandays[2].v,
      expiredAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).format(
        "yyyy-MM-dd"
      ),
      designeeId: "",
      // <-提交数据

      couponlist: [],
      loanInfoList: [], //分标
      loanInfoLoading: false,
      mgrate: 0, //管理费率
      mgrate1: 0,
      displayRate: 0,
      couponRate: 0, //管理费优惠费率
      submitState: null, //提交状态
      remnant: 0,
      mgrconfig: {},
      value: 100,
    };
  },
  methods: {
    //私标
    keyUp() {
      this.designeeId = this.designeeId.replace(/[^\d]/g, "");
    },
    // 重置
    reset() {
      this.pledgeIds = [];
      this.amount = "";
      this.couponId = "";
      this.rate = "";
      this.description = "";
      this.oanCycleDay = this.loandays[2].v;
      this.designeeId = "";
      this.checkAll = false;
      this.amountUp = 0;
      this.getdn();
      this.getCoupon();
      this.getMgrate();
    },
    // 获取质押域名
    async getdn() {
      let res = await this.$axios.get("/Member/RZJLoan/AvailablePledgeList");
      if (res.err) return res.throw();
      this.dnlist = res;
    },
    // 全选
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.pledgeIds = this.dnlist.map((v) => v.Id);
      } else {
        this.pledgeIds = [];
        this.loanInfoList = [];
      }
      this.culeAmountUp();
      this.getLoanInfo();
    },
    // 单选
    checkAllGroupChange(data) {
      if (data.length === this.dnlist.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
      this.culeAmountUp();
      this.getLoanInfo();
    },
    // 计算借款上限
    culeAmountUp() {
      let am = 0;
      this.dnlist.forEach((v) => {
        if (this.pledgeIds.indexOf(v.Id) > -1) {
          am += v.AvailableAmount;
        }
      });
      this.amountUp = am;
    },
    // 失去焦点
    handleBlur(type) {
      if (type == "rate") {
        if (isNaN(this.rate)) return (this.rate = "");
        if (this.rate > 25) {
          this.rate = 25;
        }
      }
      this.getLoanInfo();
    },
    //金额改变后
    handleChange(type) {
      if (type == "amount") {
        if (!this.pledgeIds.length)
          return this.$Message.error(this.$t("msg.m49"));
        if (isNaN(this.amount)) return (this.amount = "");
        if (this.amount.length > this.amountUp.toString().length) {
          this.amount = this.amountUp;
          this.value = this.amountUp.toString().length;
        }
      }
      this.getMgrate();
    },
    //输入金额失去焦点
    blurChage(type) {
      if (type == "amount") {
        if (!Number(this.amount)) {
          this.amount = null;
        }
        if (this.amount > this.amountUp) {
          this.amount = this.amountUp;
        } else {
          this.amount = Number(this.amount).toString();
        }
      }
    },
    // 获取优惠券
    async getCoupon() {
      let res = await this.$axios.get(
        "/Member/RZJLoan/AvailableManageFeeCoupon"
      );
      if (res.err) return;
      this.couponlist = res;
    },
    // 获取分标
    async getLoanInfo() {
      if (!this.pledgeIds.length || !this.amount || !this.rate)
        return (this.loanInfoList = []);
      this.loanInfoLoading = true;
      let res = await this.$axios.post("/Member/RZJLoan/SeparateLoanInfo", {
        pledgeIds: this.pledgeIds.join(","),
        amount: this.amount,
        rate: this.rate,
        loanCycleDay: this.loanCycleDay,
      });
      this.loanInfoLoading = false;
      if (res.err) {
        this.loanInfoList = [];
      } else {
        this.loanInfoList = res;
      }
    },
    // 获取管理费率
    async getMgrate() {
      if (this.amount == "") return;
      this.couponId = "";
      let res = await this.$axios.get(
        "/Member/RZJLoan/LoanCycleManagementFeeRate",
        {
          params: {
            loanCycleDay: this.loanCycleDay,
            thisTimeLoanAmount: this.amount,
          },
        }
      );
      if (res.err) return res.throw();
      this.mgrate = res;
      this.mgrate1 = res;
    },
    //获取管理费率配置
    async getMgrConfig() {
      let res = await this.$axios.get(
        "/Member/RZJLoan/GetAllManagementFeerateConfig"
      );
      if (res.err) return res.throw();
      this.mgrconfig = res;
    },
    // 提交
    async submit() {
      this.submitState = "loading";
      let res = await this.$axios.post("/Member/RZJLoan/PledgeLoan", {
        pledgeIds: this.pledgeIds.join(","),
        amount: this.amount,
        couponId: this.couponId,
        rate: this.rate,
        description: this.description,
        loanCycleDay: this.loanCycleDay,
        expiredAt: this.expiredAt,
        designeeId: this.designeeId,
      });
      res.throw();
      if (res.err) {
        this.submitState = "error";
      } else {
        this.submitState = "success";
        this.$router.push({ name: "loanOrder" });
      }
    },
    protocolShow(arr) {
      this.$refs.Protocol.type = arr;
      this.$refs.Protocol.modal = true;
    },
    agreechange() {
      if (!this.agree) return;
      this.protocolShow([1, 3]);
    },
    desc() {
      this.remnant = this.description.length;
    },
    coupon(val) {
      if (this.mgrate1 > val) {
        this.mgrate = val;
      } else if (this.mgrate1 <= val) {
        this.$Message.error(this.$t("msg.m125"));
        this.couponId = "";
      }
    },
    noCoupon() {
      if (this.amount != "" && this.loanCycleDay != "") {
        this.getMgrate();
      }
    },
  },
  watch: {
    loanCycleDay() {
      this.getMgrate();
      this.getLoanInfo();
    },
  },
  computed: {
    // 期数
    stagCount() {
      return comp.stag(this.loanCycleDay);
    },
    // 每期利息
    interest() {
      return comp.interest(this.amount, this.rate / 100, this.loanCycleDay);
    },
    // 管理费
    mgfee() {
      return comp.manageFee(this.amount, this.mgrate);
    },
    //优惠券汇率
    safe() {
      return this.$store.state.user.safe;
    },
    btnDisable() {
      return (
        !this.amount ||
        isNaN(this.amount) ||
        !this.rate ||
        isNaN(this.rate) ||
        !this.pledgeIds.length ||
        !this.agree
      );
    },
  },
  mounted() {
    this.getdn();
    this.getCoupon();
    this.getMgrate();
    this.getMgrConfig();
  },
};
</script>

<style lang="less" scoped>
.borrowBox {
  margin: 30px 0 25px;
  background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
  background-size: 78px 74px;
  background-position: 1px 90px;
  .Light-color {
    color: #7b7b7c;
  }
  .org {
    color: #ff6106;
  }
  .red {
    color: #f64750 !important;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(35, 35, 37, 1);
    margin-bottom: 10px;
  }
  .top {
    font-size: 14px;
    color: #333333;
    height: 350px;
    width: 1200px;
    letter-spacing: 1px;
    padding-top: 60px;
    background: url("../../assets/assetcenter/credit_img.png") right no-repeat;
    background-size: 414px 350px;
    .tip {
      font-weight: 500;
      color: rgba(94, 143, 252, 1);
      font-size: 14px;
      margin-bottom: 30px;
      span {
        margin-left: 5px;
      }
      i {
        display: inline-block;
        background: url("../../assets/assetcenter/public_hint.png") no-repeat;
        width: 14px;
        height: 13px;
        background-size: cover;
      }
    }
    /deep/ p {
      margin-bottom: 20px;
    }
  }
  .borrowMsg {
    position: relative;
    .private {
      width: 216px;
      height: 37px;
      background: rgba(94, 143, 252, 1);
      border-radius: 4px 4px 0px 0px;
      font-size: 14px;
      color: #fff;
      padding-left: 10px;
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      top: 0;
      .i1 {
        background-position: 0 0;
      }
      .write {
        display: inline-block;
        position: relative;
        margin-left: 10px;
        width: 14px;
        height: 16px;
        background: url("../../assets/borrow/pic_edit@2x.png") no-repeat;
        background-size: cover;
      }
      /deep/.ivu-input-wrapper {
        width: 95px;
        border-right: 1px solid #fff;
        .ivu-input {
          width: 83px;
          height: 20px;
          border-radius: 0;
          color: #fff;
          border: rgba(94, 143, 252, 1);
          background: rgba(94, 143, 252, 1);
        }
      }
    }
    .content {
      height: 292px;
      background: #fff;
      font-size: 14px;
      color: #232325;
      /deep/.ivu-checkbox-wrapper {
        font-size: 14px;
        .ivu-checkbox-inner {
          margin-right: 5px;
        }
      }
      .tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid #f0f1f9;
        border-right: 1px solid #f0f1f9;
        padding: 0 33px;
        font-weight: 500;
      }
      .list {
        padding: 20px 0 0 30px;
        height: 206px;
        border-right: 1px solid #f0f1f9;
        overflow-y: auto;
        li {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }

      .list2 {
        height: 232px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #7b7b7c;
        border-right: 1px solid #f0f1f9;
        .bg {
          margin-top: -20px;
          width: 197px;
          height: 197px;
          background: url("../../assets/borrow/pic_qs3@2x.png") no-repeat;
          background-size: cover;
        }
        p > a {
          color: #6292fc;
        }
      }
      .input-box {
        margin: 30px 0 0 30px;
        font-size: 14px;
        color: #232325;
        .mar-b40 {
          margin-bottom: 40px !important;
        }
        .block {
          margin-bottom: 20px;
          /deep/.ivu-input-wrapper {
            width: 176px;
            margin-left: 20px;
            position: relative;
            .ivu-input {
              padding-right: 26px;
            }
          }
          .s1 {
            position: absolute;
            right: 0;
            top: 10px;
          }
          .s2 {
            width: 500px;
            position: absolute;
            left: 76px;
            bottom: -25px;
            font-size: 12px;
            color: #232325;
            span {
              display: inline;
            }
          }
          /deep/.ivu-select {
            width: 176px;
            margin-left: 20px;
          }
          span {
            color: #7b7b7c;
            width: 56px;
            display: inline-block;
          }
        }
        .mangeRate {
          display: flex;
          align-items: center;
          .m1 {
            color: #7b7b7c;
            align-items: center;
            display: flex;
            .i2 {
              background: url("../../assets/borrow/public_moremsg.png")
                no-repeat;
              background-size: cover;
              margin-left: 5px;
              cursor: pointer;
              .ratelist {
                display: none;
                position: absolute;
                left: -20px;
                top: -295px;
                z-index: 100;
                width: 450px;
                // display: flex;
                border: 1px solid #ccc;
                color: #333;
                font-size: 14px;
                font-style: normal;
                border-radius: 4px;
                background: #fff;
                .time {
                  border-right: 1px solid #ccc;
                  width: 130px;
                  p {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 10px;
                    border-bottom: 1px solid #ccc;
                  }
                  p:last-child {
                    border-bottom: 0;
                  }
                  p:first-child {
                    background: #f1f2f5;
                  }
                }
                .rate {
                  width: 320px;
                  p {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 10px;
                    border-bottom: 1px solid #ccc;
                  }
                  p:last-child {
                    border-bottom: 0;
                  }
                  p:first-child {
                    background: #f1f2f5;
                  }
                }
              }
              &:hover {
                .ratelist {
                  display: flex;
                }
              }
            }
          }
          /deep/.ivu-select-selection {
            border-radius: 0px 8px 8px 0px;
          }
          .mgrate {
            width: 88px;
            height: 40px;
            padding-left: 20px;
            background: #f2f4f9;
            border-radius: 8px 0px 0px 8px;
            line-height: 40px;
            border-right: 1px solid #ccc;
          }
        }
        .block1 {
          position: relative;
          p {
            display: inline-block;
            span {
              color: #7b7b7c;
              display: block;
              text-align: center;
            }
          }
          /deep/.ivu-input-wrapper {
            .ivu-input {
              height: 88px;
              resize: none;
            }
            width: 460px;
            margin-left: 20px;
          }
          .s3 {
            position: absolute;
            right: 45px;
            bottom: 5px;
            color: #7b7b7c;
          }
        }
      }
    }
  }
  .confirmMsg {
    margin-top: 30px;
    position: relative;
    .time {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #232325;
      font-weight: 500px;
      position: absolute;
      right: 30px;
      top: 10px;
    }
    .content {
      background: #fff;
      .breakBox {
        .relative {
          display: flex;
          border-bottom: 1px solid #f0f1f9;
          > div {
            padding-right: 38px;
            min-width: 120px;
            display: flex;
            align-items: center;
            font-size: 14px;
            /deep/.ivu-btn {
              height: 24px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              border-radius: 4px;
              background: #6a98ff;
            }
          }
        }
        p {
          font-size: 14px;
          color: #232325;
          font-weight: 500;
        }
        .head {
          height: 56px;
          padding-left: 10px;
          margin: 0 20px;
          background: url("../../assets/borrow/pic_line@2x.png") no-repeat
            bottom;
          background-size: 1160px 9px;
          line-height: 50px;
        }
        ul {
          width: 100%;
          padding: 10px 0 10px 30px;
          // max-height: 123px;
          overflow-y: auto;
          li {
            display: flex;
            padding: 5px 0;
            p:first-child {
              width: 20%;
              display: flex;
              align-items: center;
              .i3 {
                display: inline-block;
                position: relative;
                width: 14px;
                height: 14px;
                margin-right: 5px;
                background: url("../../assets/borrow/pic_view@2x.png");
                background-size: cover;
                margin-left: 10px;
                &::before {
                  display: none;
                  content: "";
                  position: absolute;
                  left: 0px;
                  top: 16px;
                  width: 0;
                  height: 0;
                  border-left: 6px solid transparent;
                  border-right: 6px solid transparent;
                  border-bottom: 6px solid #fff;
                  z-index: 5;
                }
                .desc1 {
                  // display: none;
                  width: 461px;
                  padding: 10px 0 15px 10px;
                  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
                  border-radius: 4px;
                  background: #fff;
                  font-style: normal;
                  font-size: 14px;
                  color: #000000;
                  position: absolute;
                  left: -15px;
                  bottom: -75px;
                }
                &:hover {
                  &::before {
                    display: block;
                  }
                  .desc1 {
                    display: block;
                  }
                }
              }
            }
            p:nth-child(2) {
              width: 20%;
              font-size: 14px;
              color: #8f8f90;
            }
            p:last-child {
              padding-right: 38px;
              width: 60%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
        }
      }
      .details-content {
        padding: 30px 0 30px 30px;
        font-size: 14px;
        color: #232325;
        .detail {
          padding-right: 30px;
          border-right: 1px solid #f0f1f9;
          .d1 {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            text-align: right;
            .allmoney {
              display: flex;
              align-items: center;
              .i2 {
                background: url("../../assets/borrow/public_moremsg.png")
                  no-repeat;
                background-size: cover;
                margin-left: 5px;
              }
            }
            &.mg {
              display: flex;
              align-items: center;
              height: 42px;
            }
          }
          p:last-child {
            font-weight: 500;

            del {
              display: block;
            }
          }
        }
        .feenum {
          padding-left: 20px;
          p {
            margin-bottom: 20px;
          }
        }
        .release {
          .check {
            margin-top: 20px;
            /deep/.ivu-checkbox-wrapper {
              font-size: 14px;
              .ivu-checkbox-inner {
                margin-right: 5px;
              }
            }
          }
          .btn {
            margin-top: 10px;
            /deep/.ivu-btn {
              font-size: 14px;
              width: 344px;
              background: #5e8ffc;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .icon-active {
    display: inline-block;
    position: relative;
    width: 14px;
    height: 14px;
    margin-right: 5px;
    background: url("../../assets/borrow/pic_info@2x.png") no-repeat;
    background-size: cover;
    background-position: -14px 0;
    &::before {
      display: none;
      content: "";
      position: absolute;
      left: 0px;
      top: -12px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid rgba(255, 255, 255, 1);
      z-index: 5;
    }
    .desc {
      display: none;
      width: 162px;
      padding: 10px 0 15px 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      background: #fff;
      font-style: normal;
      font-size: 14px;
      color: #000000;
      position: absolute;
      left: -25px;
      bottom: 26px;
      z-index: 5;
    }
    &:hover {
      &::before {
        display: block;
      }
      .desc {
        display: block;
      }
    }
  }
}
</style>

